import campaignData from "../.sourceflow/campaign_blogs.json";
import mcqData from "../.sourceflow/campaign_mcq_blogs.json";
import carouselData from "../.sourceflow/campaign_carousel_blogs.json";

export const getCampaignBlogs = ({ limit } = {}) => {
  const blogs = [
    ...(campaignData?.category_values ?? []).map((b) => ({ ...b, blog_type: "blogs", url_pattern: campaignData?.url_pattern })),
    ...(mcqData?.category_values ?? []).map((b) => ({ ...b, blog_type: "mcq_blogs", url_pattern: mcqData?.url_pattern })),
    ...(carouselData?.category_values ?? []).map((b) => ({ ...b, blog_type: "carousel_blogs", url_pattern: carouselData?.url_pattern })),
  ].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  return limit ? blogs.slice(0, limit) : blogs;
};

export const useCampaignBlogs = (options) => getCampaignBlogs(options);

// The page builder only passes the props its template maps, so a blog template that
// doesn't map {{Author}} can still find its own record by title to read the author from.
export const findCampaignBlogByTitle = (title) => {
  if (!title) {
    return null;
  }

  const match = String(title).trim().toLowerCase();

  return (
    getCampaignBlogs().find(
      (blog) => String(blog?.title?.en ?? "").trim().toLowerCase() === match
    ) ?? null
  );
};

export default useCampaignBlogs;
